import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import NProgress from 'nprogress';
import { Box, LinearProgress } from '@mui/material';

const PREFIX = 'LoadingScreen';
const classes = {
    root: `${PREFIX}-root`,
};
const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        minHeight: '100%',
        padding: theme.spacing(3),
    },
}));
const LoadingScreen = (props) => {
    useEffect(() => {
        NProgress.start();
        return () => {
            NProgress.done();
        };
    }, []);
    return (jsx(Root, Object.assign({ className: classes.root }, props, { children: jsx(Box, Object.assign({ width: 400 }, { children: jsx(LinearProgress, {}) })) })));
};

export { LoadingScreen };
